import React from 'react'
import { WalletsList } from './list/page'

export const WalletsPage = () => <WalletsList />
